import React, { Component } from "react";
import InfoCard from "./InfoCard";

class CenterIntro extends Component {
  // Function to parse and render text with formatting
  parseText = (text) => {
    if (typeof text !== "string") return text;

    // Split by formatting markers while preserving them
    const parts = text.split(/(\*\*.*?\*\*|__.*?__|_.*?_|\*.*?\*)/g);

    return parts.map((part, index) => {
      // Bold: **text**
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      }
      // Underline: __text__
      if (part.startsWith("__") && part.endsWith("__")) {
        return <u key={index}>{part.slice(2, -2)}</u>;
      }
      // Italic: *text* or _text_
      if (
        (part.startsWith("*") && part.endsWith("*")) ||
        (part.startsWith("_") && part.endsWith("_"))
      ) {
        return <em key={index}>{part.slice(1, -1)}</em>;
      }
      return part;
    });
  };

  renderContent = (item, index) => {
    // If item is an object with bullets property, render as list
    if (typeof item === "object" && item.bullets) {
      return (
        <ul key={index}>
          {item.bullets.map((bullet, bulletIndex) => (
            <li key={bulletIndex}>{this.parseText(bullet)}</li>
          ))}
        </ul>
      );
    }
    // Otherwise render as paragraph
    return item ? <p key={index}>{this.parseText(item)}</p> : null;
  };

  render() {
    const { title, chip, content = [] } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div
            className="col-md-7 m-auto"
            style={{ paddingRight: 24 }}
          >
            {chip && <span className="chip m-0">{chip}</span>}
            {title && <h2 className="m-0">{title}</h2>}
            {Array.isArray(content) && content.map(this.renderContent)}
          </div>
        </div>
        {/* <div className="row">
          <div className="col-md-4">
            <InfoCard
              style="#E8F3DA"
              title="How might we make it easier for brokers and agents to generate and bind insurance quotes, saving them time and money?"
              content=""
            />
          </div>
        </div> */}
      </div>
    );
  }
}

export default CenterIntro;
